import React from "react";

const COLORS = [
  "#00cc44", "#44cc00", "#88cc00", "#bbcc00", "#ddaa00",
  "#ee8800", "#ee5500", "#ee2200", "#dd0000", "#cc0000",
];

export default function PainBarChart({ painassesment }) {
  const level = Math.min(10, Math.max(0, Math.round(painassesment || 0)));
  const color = level >= 8 ? "#cc0000" : level >= 5 ? "#ee6600" : level >= 3 ? "#ddaa00" : "#00cc44";

  return (
    <div style={{ padding: "10px 0 4px", textAlign: "center" }}>
      <p style={{ fontSize: 11, color: "#64748b", marginBottom: 8, fontWeight: 500 }}>
        Pain Assessment
      </p>
      <div style={{ display: "flex", gap: 3, justifyContent: "center", alignItems: "flex-end", height: 40 }}>
        {Array.from({ length: 10 }, (_, i) => {
          const isActive = i + 1 <= level;
          return (
            <div
              key={i}
              style={{
                width: 12,
                height: 16 + i * 2.4,
                borderRadius: 3,
                backgroundColor: isActive ? COLORS[i] : "#e8ecf0",
              }}
            />
          );
        })}
      </div>
      <p style={{ fontSize: 12, marginTop: 6, fontWeight: 600, color }}>
        {level > 0 ? `Level ${level} / 10` : "Not assessed"}
      </p>
    </div>
  );
}
